import { themeMaterial } from 'ag-grid-enterprise';
import { lightMuiTheme } from './lightMuiTheme';
import { colorSchemeLight } from 'ag-grid-community';
import { darkMuiTheme } from './darkMuiTheme';

export const lightAgGridTheme = themeMaterial.withPart(colorSchemeLight).withParams({
    foregroundColor: lightMuiTheme.palette.text.primary,
    headerTextColor: lightMuiTheme.palette.text.primary,
    headerBackgroundColor: '#f5f5f5',
    oddRowBackgroundColor: '#fafafa',
    headerColumnResizeHandleColor: lightMuiTheme.palette.divider,
    accentColor: lightMuiTheme.palette.info.main,
    borderRadius: lightMuiTheme.shape.borderRadius,
    headerFontWeight: 'bold',
    rowHeight: 25,
    cellHorizontalPadding: 20,
    iconButtonBorderRadius: lightMuiTheme.shape.borderRadius,
});
